import { createAsyncThunk } from '@reduxjs/toolkit';

import { ConfirmEmailProps } from 'models/form';

import { asyncPayloadCreator } from 'utils';

import { RegistrationService } from 'api';

export const confirmEmail = createAsyncThunk(
	'registration/register/confirm',
	(credentials: ConfirmEmailProps, { rejectWithValue }) =>
		asyncPayloadCreator(credentials, { rejectWithValue }, RegistrationService.confirmEmail),
);
